import axios from 'axios';
import { useState } from 'react';
import { config } from '@tools/ui/consts';
import { logger } from '@tools/ui-utils/logger.util';
import useOnMount from '../../../../../libs/ui/hooks/src/lib/useOnMount.hook';
import { verifyVpn } from '../api/vpn.api';

export const useVerifyVpn = () => {
  const [isVpnConnected, setIsVpnConnected] = useState(config.isLocalMode);
  const [isVerifyingVpn, setIsVerifyingVpn] = useState(!config.isLocalMode);

  useOnMount(() => {
    if (isVpnConnected) {
      return undefined;
    }

    const source = axios.CancelToken.source();

    const checkVpnConnection = async () => {
      try {
        await verifyVpn(source);
        setIsVpnConnected(true);
      } catch (e) {
        if (axios.isAxiosError(e) && e.code === 'ECONNABORTED') {
          logger.info('You may be disconnected from Twingate.', {});
        } else {
          logger.error(`Error verifying VPN connection ${e}`, {});
        }
      } finally {
        setIsVerifyingVpn(false);
      }
    };

    checkVpnConnection();

    return () => {
      source.cancel('Request canceled by cleanup');
    };
  });

  return { isVpnConnected, isVerifyingVpn };
};
